export const TRANSPORT_TYPES = {
    FUEL_TANK: 6,
    CRANE: 7,
};

export const GUARD_BITS = {
    TOTAL_LENGTH: 9,
    TANK_SECTIONS: 6,
};

export const GUARD_BIT_INDICES = {
    TRAILER: 0,
    ALARM: 1,
    COVER: 2,
};

export const FUEL_TANK_SKIP_INDICES = [0, 2];

export const DUN_COVER_LIMIT = config.dunCoverLimit;

export const COVER_POSITIONS = {
    DUAL: 'dual',
    RIGHT: 'right',
    LEFT: 'left',
};

export const GUARD_ACTIONS = {
    TANK_LOCK: (index) => index + 11,
    TANK_UNLOCK: (index) => index + 1,
    COVER_LOCK: 17,
    COVER_UNLOCK: 7,
    TRAILER_LOCK: 19,
    TRAILER_UNLOCK: 9,
    ALARM_DISABLE: 10,
    GUARD_LOCK: 18,
    GUARD_UNLOCK: 8,
    UZA_RELAY_OPEN: 30,
    UZA_RELAY_CLOSE: 31,
};

export const COLOR_CLASSES = {
    INHERIT: 'MuiPaperProgress-colorInherit',
    PRIMARY: 'MuiPaperProgress-colorPrimary',
    ERROR: 'MuiPaperProgress-colorError',
};
